module.exports = __webpack_public_path__ + "static/media/19ESCAP15.1955d090.jpg";